import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CarAccidentDrawer from "./modules/CarAccidentDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction } from '@api/manage';
import { queryUserTreeList as _queryUserTreeList } from '@/api/api';
import moment from 'moment';
export default {
  name: 'CarAccidentList',
  mixins: [JeecgListMixin],
  components: {
    CarAccidentDrawer: CarAccidentDrawer
  },
  data: function data() {
    return {
      permissionObj: {
        add: 'car:ea_asset_car_accident:add',
        delete: 'car:ea_asset_car_accident:delete',
        edit: 'car:ea_asset_car_accident:edit',
        deleteBatch: 'car:ea_asset_car_accident:deleteBatch'
      },
      pagePath: '/ea/asset/car/accident',
      pageTitle: '车辆事故登记',
      autoLoadInit: false,
      carShow: true,
      carList: [],
      userTree: [],
      //人员信息
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'card',
        colName: 'car_id',
        title: '车牌号',
        align: 'center'
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '登记人',
        align: 'center'
      }, {
        dataIndex: 'location',
        colName: 'location',
        title: '事故地点',
        align: 'center'
      }, {
        dataIndex: 'sdate',
        colName: 'sdate',
        title: '事故时间',
        align: 'center'
      }, {
        dataIndex: 'liable_dictText',
        colName: 'liable',
        title: '事故责任方',
        align: 'center'
      }, {
        dataIndex: 'damage_dictText',
        colName: 'damage',
        title: '车辆损坏程度',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      url: {
        carList: '/ea/asset/car/queryCarCards'
      },
      keys: [],
      roleList: '',
      addTime: '',
      buTime: '',
      siteName: ''
    };
  },
  props: {
    carId: {
      type: Number,
      default: null
    },
    carDetails: Boolean
  },
  created: function created() {
    if (this.carDetails) {
      this.queryParam.carId = this.carId;
      this.carShow = !this.carDetails;
    }

    this.queryUserTreeList();
    this.queryCarList();
    this.model = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
    this.keys = JSON.parse(window.localStorage.getItem('pro__Login_Userinfo'));
    this.loadData(); // this.buTime = new Date(this.model).getTime()
    //   this.addTime = new Date(record.createTime).getTime()
    //   if (this.$store.getters.userInfo.roleList.includes('administrator')) {
    //     this.handleDetail()
    //     }
  },
  computed: {},
  methods: {
    /**
     * 时间筛选
     * @param value
     * @param sdate
     */
    onDateSdate: function onDateSdate(value, sdate) {
      this.queryParam.stime = sdate;
    },
    searchReset: function searchReset() {
      this.queryParam = {
        carId: this.carId
      };
      this.dates = {};
      this.loadData(1);
    },
    modalFormOk: function modalFormOk() {
      this.queryParam = {
        carId: this.carId
      };
      this.loadData(1);
    },
    //查询
    searchQuery: function searchQuery() {
      if (this.$refs.page) {
        this.$refs.page.resetPage();
      } else {
        this.loadData(1);
      }
    },
    getAuth: function getAuth(id) {
      if (this.$store.getters.userInfo.roleList.includes('administrator') || this.$store.getters.userInfo.roleList.includes('tenant_admin')) {
        return true;
      } else {
        return id == this.$store.getters.userInfo.id && this.buTime - this.addTime < 60 * 60 * 1000; // show=false
      }
    },
    //车牌信息列表
    queryCarList: function queryCarList() {
      var that = this;
      that.carList = [];
      getAction(that.url.carList).then(function (res) {
        if (res.success) {
          that.carList = res.result;
        }
      });
    },
    queryUserTreeList: function queryUserTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      _queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    handleAdd: function handleAdd() {
      if (this.carId != null) {
        this.$refs.modalForm.add(this.carId);
      } else {
        this.$refs.modalForm.add();
      }

      this.$refs.modalForm.title = '新增：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.showContact = false;
    },
    // handleDetail: function (record) {
    //   this.buTime = new Date(this.model).getTime()
    //   this.addTime = new Date(record.createTime).getTime()
    //   if (this.$store.getters.userInfo.roleList.includes('administrator')) {
    //     this.handleDetail()
    //     this.$refs.modalForm.edit(record)
    //     this.$refs.modalForm.title = this.pageTitle + '详情'
    //     this.$refs.modalForm.disableSubmit = true
    //     this.$refs.modalForm.disableStatus = true
    //     this.$refs.modalForm.showTab = true
    //     this.$refs.modalForm.showContact = false
    //   } else if (this.buTime - this.addTime < 60 * 60 * 1000) {
    //     this.$refs.modalForm.edit(record)
    //     this.$refs.modalForm.title = this.pageTitle + '详情'
    //     this.$refs.modalForm.disableSubmit = true
    //     this.$refs.modalForm.disableStatus = true
    //     this.$refs.modalForm.showTab = true
    //     this.$refs.modalForm.showContact = false
    //   }
    // },
    handleEdit: function handleEdit(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;

      if (this.carId != null) {
        this.$refs.modalForm.disableStatus = true;
      } else {
        this.$refs.modalForm.disableStatus = false;
      }

      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.showContact = true;
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};